<!-- 审核 -->
<template>
  <div class="diseaseList">
    <!-- TODO:封装selectForm筛选 -->
    <el-form :inline="true">
      <!-- <el-button type="primary" size="small" v-waves @click="handleAdd"
        >新增</el-button
      >-->
      <el-form-item label="所属门店:" style="margin:20rpx 20rpx 0 20rpx" size="small">
        <el-select v-model="listQuery.store_id" placeholder="请选择" clearable multiple collapse-tags>
          <div v-for="(item, index) in filterStoreList" :key="index">
            <el-option :label="item.store_name" :value="item.store_id + ''"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态:" style="margin:20rpx 20rpx 0 20rpx" size="small">
        <el-select v-model="listQuery.status" placeholder="请选择" clearable>
          <div v-for="(item, index) in stateList" :key="index">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="订单类型:" style="margin:20rpx 20rpx 0 20rpx" size="small">
        <el-select v-model="listQuery.type" placeholder="请选择" style="width: 100%;" clearable>
          <div v-for="(item, index) in typeList" :key="index">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="手机号: " style="margin:20rpx 20rpx 0 20rpx" size="small">
        <el-input v-model="listQuery.phone" placeholder="请输入商品名称" clearable></el-input>
      </el-form-item>
      <el-button type="primary" @click="getListData" size="small" v-waves class="btn-green">搜索</el-button>
    </el-form>
    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="store_id" slot-scope="{ row }">
          <StoreToString :store_id="String(row.storeId)" />
        </template>
        <template slot="status" slot-scope="scope">
          <!-- <FillingStatus :value="scope.row.status" /> -->
          {{
          scope.row.status === 1
          ? "待支付"
          : scope.row.status === 2
          ? "进行中"
          : scope.row.status === 3
          ? "已完成"
          : scope.row.status === 4
          ? "退款中"
          : scope.row.status === 5
          ? "已退款"
          : ""
          }}
        </template>
        <template slot="payStyle" slot-scope="scope">
          {{
          scope.row.payStyle == 1
          ? "门店线下支付"
          : scope.row.payStyle == 2
          ? "会员卡支付" : scope.row.payStyle == 3
          ? "微信支付"
          : "/"
          }}
        </template>

        <template slot="type" slot-scope="scope">
          {{
          scope.row.type === 1
          ? "门店订单"
          : scope.row.type === 2
          ? "微商城"
          : scope.row.type === 3
          ? "积分商城"
          : ""
          }}
        </template>
        <template slot="detail" slot-scope="scope">
          <div>
            <el-tag
              effect="dark"
              size="mini"
            >取货号:{{ scope.row.takeCode ? scope.row.takeCode : "暂无" }}</el-tag>
            <el-tag
              effect="dark"
              size="mini"
              style="margin-left: 20px;"
            >桌号:{{ scope.row.tableNumber ? scope.row.tableNumber : "暂无" }}</el-tag>
          </div>
          <div v-for="(item, index) in scope.row.productList" :key="index" style="margin: 5px 0;">
            {{
            item.productName +
            (item.sku ? "(" + item.sku + ")" : "") +
            item.price
            }}
            X
            {{ item.num }}
          </div>
        </template>

        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" type="text" @click="handleEdit(row)" class="text-green">编辑</el-button>
            <el-button size="mini" type="text" @click="handleSend(row)" primary>取货号播报</el-button>
            <el-button
              size="mini"
              type="text"
              @click="handleDelete(row)"
              style="color: rgb(255, 0, 0);"
             class="text-red">删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>
    <!-- 弹窗表单 -->
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="dialogForm" label-width="80px">
        <el-form-item label="姓名">
          <el-input clearable v-model="dialogForm.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input clearable v-model="dialogForm.phone" disabled></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input type="textarea" clearable v-model="dialogForm.address" disabled></el-input>
        </el-form-item>

        <el-form-item label="订单状态:">
          <el-select v-model="dialogForm.status" placeholder="请选择" style="width: 100%;" clearable>
            <div v-for="(item, index) in stateList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>

        <el-form-item label="订单类型:">
          <el-select v-model="dialogForm.type" placeholder="请选择" style="width: 100%;" clearable>
            <div v-for="(item, index) in typeList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="订单备注">
          <el-input type="textarea" clearable v-model="dialogForm.odescribe"></el-input>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input clearable v-model="dialogForm.logisticsNumber"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
// import filterQueryFormItems from "./filterQueryFormItems";
import Percentage from "@/components/filters/Percentage.vue";
import FillingStatus from "@/components/filters/FillingStatus.vue";
import KindTab from "@/components/tab/kindTab/index.vue";
// import waves from "@/directive/waves/index.js"; // 水波纹指令
import {
  updateOrder,
  selectOrder,
  deleteOrder,
  sendNumber
} from "@/services/orderPage/index";
import { mapState } from "vuex";
import StoreToString from "@/components/filters/storeToString.vue";
export default {
  components: {
    ElTable,
    Percentage,
    FillingStatus,
    KindTab,
    StoreToString
  },
  async created() {
    this.getListData();
  },
  // directives: {
  //   waves,
  // },
  data() {
    return {
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      /* 表格数据 */
      tableData: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},
      stateList: [
        { id: 0, name: "全部" },
        { id: 1, name: "待支付" },
        { id: 2, name: "进行中" },
        { id: 3, name: "已完成" },
        { id: 4, name: "退款中" },
        { id: 5, name: "已退款" }
      ],
      typeList: [
        { id: 1, name: "门店订单" },
        { id: 2, name: "微商城" },
        { id: 3, name: "积分商城" }
      ]
    };
  },
  computed: {
    // filterQueryFormItems,
    listHeader,
    ...mapState(["userInfo", "filterStoreList"])
  },
  watch: {},
  methods: {
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));

      this.loading = true;
      const { data, code, count } = await selectOrder(listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索按钮 */
    async search(listQuery) {
      console.log("listQuery", listQuery);
      this.listQuery = listQuery;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建订单";
      this.dialogForm = {};
    },

    /* 修改 */
    handleEdit(row) {
      console.log(row);
      this.dialogVisible = true;
      this.dialogName = "编辑订单";
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    /* 保存 */
    save() {
      if (this.dialogName === "创建订单") {
        // addOrder(this.dialogForm).then((res) => {
        //   console.log("创建订单", res);
        //   if (res.code === 200) {
        //     this.listQuery.pageNumber = 1;
        //     this.getListData();
        //     this.$message({
        //       type: "success",
        //       message: "创建成功!",
        //     });
        //     this.dialogVisible = false;
        //   }
        // });
      }
      if (this.dialogName === "编辑订单") {
        updateOrder(this.dialogForm).then(res => {
          console.log("编辑订单", res);
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "编辑成功!"
            });
            this.dialogVisible = false;
          }
        });
      }
    },
    /* 播报 */
    async handleSend(row) {
      let result = await sendNumber({
        store_id: row.storeId,
        number: row.takeCode
      });
      if (result.code === 200) {
        this.$message({
          type: "success",
          message: "播报成功!"
        });
      }
    },
    /* 删除 */
    handleDelete(row) {
      this.$confirm("此操作将永久删除该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteOrder({ id: row.id }).then(res => {
            console.log(res);
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.getListData();
            }
          });
        })
        .catch(() => {});
    },

    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    }
  }
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
}

.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}

.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}
</style>
